/** @jsxImportSource @emotion/react */
import { memo } from "react";

import {
  mtgGroup,
  mtgCaption,
} from "assets/css/stylesCss";

import LabelWithOptionIcon from "components/ui/label/LabelWithOptionIcon";
import InputTextHalf from "components/ui/input/InputTextHalf";

/**
 * お名前（カタカナ）
 * @param {String} seiKn セイ react-hook-form管理用フォーム特定文字列
 * @param {String} meiKn メイ react-hook-form管理用フォーム特定文字列
 * @param {Boolean} required true : 必須
 *                           false: 任意
 * @param {String} maxLength 最大文字数
 * @param {String} txtCaption キャプション 注釈
 */
const NameKn = memo(({ seiKn, meiKn, required, maxLength, txtCaption }) => {

  // 入力チェック
  const regex = /^[ァ-ワヲ-ヶＡ-Ｚ０-９　、，．・：；？！｀＾＿ー／～｜（）［］｛｝「」＋－＝″￥＄％＃＆＊＠’＜＞。ﾞﾟ゛゜]*$/;

  return (
    <div css={mtgGroup}>
      {/** ラベル */}
      <LabelWithOptionIcon required={required}>
        お名前（カタカナ）
      </LabelWithOptionIcon>
      <InputTextHalf
        items={[
          {
            name: seiKn,
            placeholder: "セイ",
            maxLength: maxLength,
            rules: {
              required: {
                value: required,
                message: "セイを入力してください。",
              },
              pattern: {
                value: regex,
                message: "利用できない文字が含まれています。",
              },
            },
          },
          {
            name: meiKn,
            placeholder: "メイ",
            maxLength: maxLength,
            rules: {
              pattern: {
                value: regex,
                message: "利用できない文字が含まれています。",
              },
            },
          },
        ]}
        isSpace={true}
        pairsValid={{
          maxSize: 20,
          message: "お名前（カタカナ）は合計19文字以内で入力してください。（セイのみの場合は20文字以内）",
        }}
      ></InputTextHalf>
      <p css={mtgCaption}>{txtCaption}</p>
    </div>
  );
});

export default NameKn;
